<div mat-dialog-content>
  <h3>{{editUser ? 'Redigera användare' : 'Skapa användare'}}</h3>
  @if (editUserForm) {
    <form [formGroup]="editUserForm">
      <mat-form-field>
        <mat-label>Användarnamn</mat-label>
        <input matInput formControlName="username" spellcheck="false" autocomplete="off">
        <mat-error>Användarnamn måste vara e-postadress</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Alias</mat-label>
        <input matInput formControlName="name" spellcheck="false" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Roller</mat-label>
        <mat-select formControlName="roles" [compareWith]="compareSelected" autocomplete="off" multiple>
          @if (roleOptions$ | async; as roleOptions) {
            @for (role of roleOptions; track role) {
              <mat-option [value]="role">{{ role.label }}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
      @if (partners) {
        <mat-form-field>
          <mat-label>Samarbetspartners</mat-label>
          <mat-select #partnerSelect formControlName="partner" [compareWith]="compareSelectedPartner" autocomplete="off">
            <ng-container>
              @for (partner of partners; track partner) {
                <mat-option [value]="partner">{{ partner.name }} </mat-option>
              }
            </ng-container>
          </mat-select>
        </mat-form-field>
      }
      @if (!editUser) {
        <mat-form-field class="wideInput">
          <mat-label>Nytt lösenord</mat-label>
          <input matInput type="password" formControlName="newPassword" spellcheck="false" autocomplete="off">
        </mat-form-field>
      }
      <!-- Force reset password for user -->
      @if (editUser) {
        <button mat-button (click)="resetPassword()">Återställ lösenord</button>
        <p class="reset-password-text">Vid "Återställ lösenord" skickas ett mejl till användaren med en länk för att återställa lösenordet.</p>
      }
    </form>
  }
</div>

<div mat-dialog-actions class="buttons">
  <button mat-button (click)="onCancelClick()">Avbryt</button>
  <div>
    @if (editUser) {
      <button mat-button color="warn" class="delete" (click)="onDeleteClick()">Ta bort</button>
    }
    <button mat-raised-button color="primary" (click)="onSaveClick()" [disabled]="!editUserForm?.valid">Spara</button>
  </div>
</div>